import { requestWithQuery } from '../../../shared/api/utils/provider';
import { CsrfSuccessResponse, User } from '../../types/user';

export function getCsrf() {
  return requestWithQuery<CsrfSuccessResponse>({ url: 'csrf', method: 'GET' });
}

export function getAuth() {
  return requestWithQuery<User>({ url: 'care/current_user', method: 'GET' });
}
